import React from 'react';

const Loader = () => (
  <div className="loader-overlay" role="status" aria-label="Loading">
    <div className="spinner-border" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

export default Loader;